import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { Button } from '@/components/ui/Button';
import { toaster } from '@/components/ui/Toaster';
import { CompanyForm } from '@/features/companies/components/CompanyForm';
import { DeleteCompanyDialog } from '@/features/companies/components/DeleteCompanyDialog';
import { GalleryImageSection } from '@/features/companies/components/GalleryImageSection';
import { companyQueries, useUpdateCompany } from '@/features/companies/api/companyQueries';

export const Route = createFileRoute('/_authenticated/companies/$companyId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(companyQueries.detail(params.companyId)),
  component: CompanyDetailPage,
});

function CompanyDetailPage() {
  const { companyId } = Route.useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery(companyQueries.detail(companyId));
  const updateMutation = useUpdateCompany();

  if (isLoading) {
    return (
      <Flex justify="center" py={8}>
        <Spinner />
      </Flex>
    );
  }

  const company = data?.company;

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          企業詳細
        </Text>
        <Button variant="outline" onClick={() => navigate({ to: '/companies' })}>
          一覧に戻る
        </Button>
      </Flex>

      <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm">
        <CompanyForm
          initialValues={company}
          onSubmit={async (values) => {
            try {
              await updateMutation.mutateAsync({ id: Number(companyId), ...values });
              toaster.success({ title: '企業情報を更新しました' });
            } catch {
              toaster.error({ title: '保存に失敗しました。時間をおいて再度お試しください' });
            }
          }}
          submitLabel="更新"
        />

        {company && (
          <Box mt={6} pt={4} borderTop="1px solid" borderColor="border.DEFAULT">
            <DeleteCompanyDialog companyId={company.id} companyName={company.name} />
          </Box>
        )}
      </Box>

      <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm" mt={6}>
        <GalleryImageSection companyId={companyId} />
      </Box>
    </Box>
  );
}
